// extracted by mini-css-extract-plugin
module.exports = {"root":"perview_root__1z3aK","img":"perview_img__2MhGn","span_button":"perview_span_button__258oK"};